import { BasicError, ContractError, HttpError } from "./Error";

export function isHttpError(error: BasicError): error is HttpError {
  return error instanceof HttpError;
}

export function isContractError(error: BasicError): error is ContractError {
  return error instanceof ContractError;
}
